import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { BaseDomainType } from '~/common/types';
import { DataFoundationPageTitle } from '~/components/DataFoundationPageTitle/DataFoundationPageTitle';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { PageLayout } from '~/components/PageLayout/PageLayout';

export const DataFoundation = () => {
  return (
    <PageLayout
      fullHeight
      renderHeader={
        <PageHeaderStatic
          title={<DataFoundationPageTitle />}
          maxWidth={false}
          icon={<WidgetIcon icon={<DomainIcon domain={BaseDomainType.DATA_FOUNDATION} />} />}
        />
      }
    ></PageLayout>
  );
};
